import {MutationTree} from 'vuex';

const mutations: MutationTree<RootState> = {
    topMessageAdd(state, data)
    {
        state.topMessages.push(data);
    },
    topMessageShift(state)
    {
        state.topMessages.shift();
    },
    flashMessageAdd(state, data)
    {
        state.flashMessages.push(data);
    },
    flashMessageRemove(state, key)
    {
        state.flashMessages.splice(key, 1);
    },
    flashMessageReset(state)
    {
        state.flashMessages = [];
    },
    setLayoutData(state, data)
    {
        for (let key in data)
        {
            if (data.hasOwnProperty(key) && state.layoutData.hasOwnProperty(key))
            {
                state.layoutData[key] = data[key];
            }
        }

        state.layoutDataLoaded = true;
    },
    loader(state, data)
    {
        state.loader = data;
    },
    hideApp(state, hideApp)
    {
        state.hideApp = hideApp;
    },
    login(state)
    {
        state.loggedIn = true;
    },
};

export default mutations;
